<template>
    <div class="no-sidebar-bg">
        <div class="w-full">
            <NuxtPage />
        </div>
    </div>
</template>

<style lang="scss" scoped>
.no-sidebar-bg {
    background: url('/assets/images/soc/bg_2.png');
    background-color: #18181B;
    height: 100vh;
    background-size: 50%;
    background-attachment: fixed;
    overflow:auto;
    padding: 24px 32px;
}

</style>
